import defaultConfig from './themes/default';
import environetConfig from './themes/environet';

export default [defaultConfig, environetConfig];
